(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aw-shop-all-grid"]) return;
  try {
    
  const initAstroWorldQuickAdd = () => {
    document.querySelectorAll('.aw-shop-all:not([data-aw-quick-add-ready])').forEach((section) => {
      section.dataset.awQuickAddReady = 'true';

      section.querySelectorAll('[data-aw-quick-add-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.awQuickAddOpen);
          if (!dialog) return;

          if (button.dataset.awCardSize) {
            const sizeFieldset = Array.from(dialog.querySelectorAll('[data-aw-option-position]')).find((fieldset) => {
              return fieldset.querySelector('legend')?.textContent.trim().toLowerCase() === 'size';
            });
            const sizeInput = Array.from(sizeFieldset?.querySelectorAll('[data-aw-option-value]') || []).find((input) => {
              return input.value === button.dataset.awCardSize;
            });
            if (sizeInput) {
              sizeInput.checked = true;
              sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }

          dialog.showModal();
        });
      });

      section.querySelectorAll('.aw-quick-add').forEach((dialog) => {
        const form = dialog.querySelector('[data-aw-quick-add-form]');
        const variantsNode = dialog.querySelector('[data-aw-quick-add-variants]');
        const variantInput = dialog.querySelector('[data-aw-variant-id]');
        const price = dialog.querySelector('[data-aw-quick-add-price]');
        const image = dialog.querySelector('[data-aw-quick-add-image]');
        const submit = dialog.querySelector('[data-aw-quick-add-submit]');
        const quantity = dialog.querySelector('[data-aw-quantity]');
        const error = dialog.querySelector('[data-aw-quick-add-error]');
        const variants = JSON.parse(variantsNode.textContent);

        const updateVariant = () => {
          const values = Array.from(dialog.querySelectorAll('[data-aw-option-position]')).map((fieldset) => {
            return fieldset.querySelector('[data-aw-option-value]:checked')?.value;
          });
          const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
          const sizeFieldset = Array.from(dialog.querySelectorAll('[data-aw-option-position]')).find((fieldset) => {
            return fieldset.querySelector('legend')?.textContent.trim().toLowerCase() === 'size';
          });
          const size = sizeFieldset?.querySelector('[data-aw-option-value]:checked')?.value;

          variantInput.value = variant?.id || '';
          submit.disabled = !variant?.available;
          submit.textContent = variant?.available
            ? `${submit.dataset.addLabel}${size ? ` · ${size}` : ''}`
            : submit.dataset.soldOutLabel;
          if (variant) price.textContent = variant.price;
          if (variant?.image && image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.imageAlt || '';
          }
          error.hidden = true;
        };

        dialog.querySelector('[data-aw-quick-add-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.querySelectorAll('[data-aw-option-value]').forEach((input) => input.addEventListener('change', updateVariant));
        dialog.querySelector('[data-aw-quantity-minus]').addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value) - 1);
        });
        dialog.querySelector('[data-aw-quantity-plus]').addEventListener('click', () => {
          quantity.value = Math.max(1, Number(quantity.value) + 1);
        });

        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          error.hidden = true;
          submit.disabled = true;
          submit.setAttribute('aria-busy', 'true');
          const previousLabel = submit.textContent;
          submit.textContent = submit.dataset.loadingLabel;

          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(variantInput.value), quantity: Math.max(1, Number(quantity.value)) }],
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
              })
            });
            const result = await response.json();
            if (!response.ok) throw new Error(result.description);

            const cartDrawer = document.querySelector('cart-drawer');
            if (cartDrawer?.renderContents) {
              dialog.close();
              cartDrawer.renderContents(result);
            } else {
              window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
            }
          } catch (requestError) {
            error.hidden = false;
            submit.disabled = false;
            submit.textContent = previousLabel;
          } finally {
            submit.removeAttribute('aria-busy');
          }
        });

        updateVariant();
      });
    });
  };

  initAstroWorldQuickAdd();
  document.addEventListener('shopify:section:load', initAstroWorldQuickAdd);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloned-blockyc-header"] && !Shopify.designMode) return;
  try {
    
  class AwMenuDrawer extends HTMLElement {
    constructor() {
      super();
      this.toggle = document.querySelector('[data-aw-menu-toggle]');
      this.overlay = this.querySelector('[data-aw-menu-overlay]');
      this.mainPanel = this.querySelector('[data-aw-menu-panel="main"]');
      this.activePanel = this.mainPanel;

      if (this.toggle) {
        this.toggle.addEventListener('click', this.open.bind(this));
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', this.close.bind(this));
      }

      this.querySelectorAll('[data-aw-menu-open-submenu]').forEach((btn) => {
        btn.addEventListener('click', () => this.showPanel(btn.getAttribute('data-aw-menu-open-submenu')));
      });
      this.querySelectorAll('[data-aw-menu-back]').forEach((btn) => {
        btn.addEventListener('click', () => this.showPanel('main'));
      });
      this.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => this.close());
      });

      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
      });
    }

    open() {
      this.classList.add('is-open');
      document.documentElement.classList.add('aw-menu-scroll-lock');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      if (typeof trapFocus === 'function') {
        trapFocus(this.activePanel, this.activePanel.querySelector('a, button'));
      }
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('aw-menu-scroll-lock');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.toggle);
      window.setTimeout(() => this.resetPanels(), 320);
    }

    resetPanels() {
      this.querySelectorAll('[data-aw-menu-panel]').forEach((panel) => {
        panel.classList.remove('is-prev');
        if (panel !== this.mainPanel) panel.classList.remove('is-active');
        const parentBtn = this.querySelector('[data-aw-menu-open-submenu="' + panel.getAttribute('data-aw-menu-panel') + '"]');
        if (parentBtn) parentBtn.setAttribute('aria-expanded', 'false');
      });
      this.mainPanel.classList.add('is-active');
      this.activePanel = this.mainPanel;
    }

    showPanel(id) {
      const target = id === 'main' ? this.mainPanel : this.querySelector('[data-aw-menu-panel="' + id + '"]');
      if (!target || target === this.activePanel) return;

      const goingBack = id === 'main';
      this.activePanel.classList.remove('is-active');
      this.activePanel.classList.toggle('is-prev', !goingBack);
      if (!goingBack) target.classList.remove('is-prev');
      target.classList.add('is-active');

      if (!goingBack) {
        const openBtn = this.querySelector('[data-aw-menu-open-submenu="' + id + '"]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      } else {
        const closedId = this.activePanel.getAttribute('data-aw-menu-panel');
        const openBtn = this.querySelector('[data-aw-menu-open-submenu="' + closedId + '"]');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      }

      this.activePanel = target;

      if (typeof trapFocus === 'function') {
        trapFocus(target, target.querySelector('button, a'));
      }
    }
  }

  if (!customElements.get('aw-menu-drawer')) {
    customElements.define('aw-menu-drawer', AwMenuDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
